import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import LoginPage from "./pages/login/index";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import VerifyOtpPage from "./pages/login/VerifyOtpPage";
import ResetPasswordPage from "./pages/login/ResetPasswordPage";
import { PanelPage } from "./pages/panel/index";
import { UsersPage } from "./pages/panel/users/index";
import { SitesPage } from "./pages/panel/sites/index";
import { AMCPage } from "./pages/panel/amc/index";
import { RefillingPage } from "./pages/panel/refilling/index";
import { ZohoInvoicesPage } from "./pages/panel/zoho/index";
import { PaymentsPage } from "./pages/panel/payments/index";
import { ReportsPage } from "./pages/panel/reports/index";
import ProtectedRoute from "./components/ProtectedRoute";
import PWAStatusBar from "./components/PWAStatusBar";
import { initInstallPrompt } from "./utils/pwaUtils";

export const API_BASE_URL = "/api/v1/"; // Change this to your backend URL

function App() {
  const { authToken, id } = useSelector((state) => state.loginData || {});
  const isAuthenticated = authToken && id;

  // Initialize PWA features
  useEffect(() => {
    initInstallPrompt();
  }, []);

  return (
    <>
      <PWAStatusBar />
      <Router>
        <Routes>
          {/* Root route - redirect based on auth status */}
          <Route 
            path="/" 
            element={
              isAuthenticated ? (
                <Navigate to="/panel/amc" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />

          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/verifyotp" element={<VerifyOtpPage />} />
          <Route path="/resetpassword" element={<ResetPasswordPage />} />

          {/* Protected Routes */}
          <Route 
            path="/panel" 
            element={
              <ProtectedRoute>
                <PanelPage />
              </ProtectedRoute>
            }
          >
            <Route path="users" element={<UsersPage />} />
            <Route path="sites" element={<SitesPage />} />
            <Route path="amc" element={<AMCPage />} />
            <Route path="refilling" element={<RefillingPage />} />
            <Route path="zoho-invoices" element={<ZohoInvoicesPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="reports" element={<ReportsPage />} />
          </Route>

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}
export default App;
